module.exports = " <div class=async-load v-if=show _v-71cd0d99=\"\"> <div class=back-block _v-71cd0d99=\"\"> <div class=roting _v-71cd0d99=\"\"></div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-71cd0d99&file=async_loading_rem.vue!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/async_loading/async_loading_rem.vue
// module id = 42
// module chunks = 1 2 3 4 5 6 7 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29